/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useAuth} from "../../../../../app/modules/auth"
import {isSuperAdmin} from "../../../../../app/utils/Utils"
import {getAllOrgSettings} from "../../../../../app/pages/generic/crud"
import {useQrDraftCount} from "../../../../../app/pages/qr-purchase/useQrDraftCount"

// Icons Reference: https://preview.keenthemes.com/html/metronic/docs/icons/keenicons

const SidebarMenuMain = () => {
    const {currentUser} = useAuth()
    const isOperator = !isSuperAdmin(currentUser)
    const [purchaseDumpLocationEnabled, setPurchaseDumpLocationEnabled] = useState(false)
    const qrDraftCount = useQrDraftCount(isOperator)

    useEffect(() => {
        getAllOrgSettings().then((res) => {
            const settings = res?.data || []
            const setting = settings.find(s => s.typeName === 'PURCHASE_DROP_LOCATION')
            setPurchaseDumpLocationEnabled(setting ? (setting.value === true || setting.value === 'true') : false)
        }).catch(() => {})
    }, [])

    // Helper component for section headers
    const SectionHeader = ({title}) => (
        <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'>{title}</span>
            </div>
        </div>
    )

    return (
        <>
            {/* Dashboard - Always visible for operators */}
            {isOperator && (
                <SidebarMenuItem to='/dashboard' icon='element-11' title='Dashboard'/>
            )}

            {/* Sales - Core weighbridge operations */}
            {isOperator && (
                <>
                    <SectionHeader title='Sales'/>
                    <SidebarMenuItem to='/pending-sales' icon='time' title='Pending Sales'/>
                    <SidebarMenuItem to='/sales-list' icon='document' title='All Sales'/>
                </>
            )}

            {/* Purchases */}
            {isOperator && (
                <>
                    <SectionHeader title='Purchases'/>
                    <SidebarMenuItem to='/pending-purchases' icon='time' title='Pending Purchases'/>
                    <SidebarMenuItem to='/draft-purchases' icon='notepad-edit' title='Draft Purchases' badge={qrDraftCount || undefined}/>
                    <SidebarMenuItem to='/purchases-list' icon='shop' title='All Purchases'/>
                    <SidebarMenuItem to='/qr-scan-log' icon='scan-barcode' title='QR Scan Log'/>
                    <SidebarMenuItem to='/qr-auto-purchase-vehicles' icon='truck' title='QR Auto-Purchase Vehicles'/>
                    {purchaseDumpLocationEnabled && <SidebarMenuItem to='/stockyard' icon='package' title='Stock Yard'/>}
                </>
            )}

            {/* Expenses */}
            {isOperator && (
                <>
                    <SectionHeader title='Expenses'/>
                    <SidebarMenuItem to='/expenses' icon='wallet' title='Expenses'/>
                </>
            )}

            {/* Reports */}
            {isOperator && (
                <>
                    <SectionHeader title='Reports'/>
                    <SidebarMenuItem to='/daily-report' icon='document' title='Daily Report'/>
                </>
            )}

            {/* Others */}
            <SectionHeader title='Others'/>

            {/* Master Data - Collapsed submenu */}
            <SidebarMenuItemWithSub to='/master-data' icon='data' title='Master Data'>
                <SidebarMenuItem to='/vehicles' icon='truck' title='Vehicles'/>
                <SidebarMenuItem to='/sales-customers' icon='people' title='Customers'/>
                <SidebarMenuItem to='/suppliers' icon='parcel' title='Suppliers'/>
                <SidebarMenuItem to='/inventory-items' icon='cube-2' title='Products'/>
                <SidebarMenuItem to='/service-items' icon='wrench' title='Services'/>
            </SidebarMenuItemWithSub>

            {/* Settings - Collapsed submenu */}
            <SidebarMenuItemWithSub to='/settings' icon='setting-2' title='Settings'>
                <SidebarMenuItem to='/org-settings' hasBullet title='Organization Settings'/>
                <SidebarMenuItem to='/ui-settings' hasBullet title='UI Settings'/>
                <SidebarMenuItem to='/wifi-settings' hasBullet title='WiFi / Network'/>
            </SidebarMenuItemWithSub>

            {/* Captured Images - Quick access for operators */}
            {isOperator && (
                <SidebarMenuItem to='/captured-images' icon='picture' title='Captured Images'/>
            )}

            {/* Sync Status */}
            <SidebarMenuItem to='/sync' icon='cloud' title='Sync Status'/>

            {/* Bottom spacing */}
            <div className="py-5">&nbsp;</div>
        </>
    )
}

export {SidebarMenuMain}
